import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Filter, Plus, Trash2 } from "lucide-react";

export default function Settings() {
  const [patterns, setPatterns] = useState([]);
  const [np, setNp] = useState("");
  const load = () => api.get("/admin/import-filters").then(({ data }) => setPatterns(data.patterns || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async (next) => {
    try { const { data } = await api.put("/admin/import-filters", { patterns: next }); setPatterns(data.patterns); toast.success("Filtri salvati"); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const add = () => { if (!np.trim()) return; save([...patterns, np.trim()]); setNp(""); };
  const remove = (i) => save(patterns.filter((_, idx) => idx !== i));
  const edit = (i, v) => setPatterns(patterns.map((p, idx) => idx === i ? v : p));

  return (
    <div className="space-y-8 max-w-3xl">
      <div><p className="text-xs uppercase tracking-[0.15em] font-bold text-stone-500">Super-admin</p>
        <h1 className="font-serif text-4xl sm:text-5xl font-light text-stone-900">Impostazioni</h1></div>

      <div className="bg-white border border-stone-200 rounded-sm p-6">
        <div className="flex items-center gap-2 mb-2"><Filter size={18} className="text-brand" /><h3 className="font-serif text-2xl text-stone-900">Filtri Import Fatture</h3></div>
        <p className="text-sm text-stone-500 mb-5">Le righe di fattura che iniziano o contengono uno di questi testi (senza distinzione maiuscole/minuscole) verranno scartate durante l'import.</p>

        <div className="flex gap-2 mb-5">
          <input data-testid="new-filter-input" value={np} onChange={(e) => setNp(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()}
            placeholder="Nuovo pattern (es. rif. ddt)" className="flex-1 border border-stone-300 bg-white px-3 py-2 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40" />
          <button data-testid="add-filter-btn" onClick={add} className="rounded-full bg-brand text-white px-5 py-2 text-sm font-semibold flex items-center gap-2 hover:bg-brand-hover"><Plus size={16} /> Aggiungi</button>
        </div>

        {patterns.length === 0 ? <p className="text-sm text-stone-400">Nessun filtro. Tutte le righe verranno importate.</p> : (
          <ul className="space-y-2" data-testid="filters-list">
            {patterns.map((p, i) => (
              <li key={i} className="flex items-center gap-2" data-testid={`filter-row-${i}`}>
                <input data-testid={`filter-input-${i}`} value={p} onChange={(e) => edit(i, e.target.value)} onBlur={() => save(patterns)}
                  className="flex-1 border border-stone-300 bg-white px-3 py-2 text-sm rounded-sm outline-none focus:ring-2 focus:ring-brand/40" />
                <button data-testid={`filter-del-${i}`} onClick={() => remove(i)} className="text-stone-400 hover:text-alert p-2"><Trash2 size={16} /></button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
